import React from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'
import titleData from '../../assets/data/titleChildren.json';

const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const Title = (props) => {
  const handleClick = (id,value,text) => {
    props.setFristChildrenTitle(value,text);
    props.history.goBack()
  }

  return (
    <Layout title={'คำนำหน้า'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกคำนำหน้า</h4>
      <Row>
        {
          titleData.map(element =>
            <StyledCol key={element.id}>
              <Text onClick={() => handleClick(element.id, element.value, element.th)}>{element.th}</Text>
              <Divider floatRight={true}/>
            </StyledCol>
          )
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setFristChildrenTitle: actions.setFristChildrenTitle
}

const TitleWithConnect = connect(null, mapDispatchToProps)(Title)

export default TitleWithConnect
